module.exports = __webpack_public_path__ + "474d01e8bc727a6da48469fc2cec5bb6.pdf";